import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'professor_courses',
  label: 'Coordenação de cursos',
  actions: ['list', 'create', 'delete'],
  onlyPermission: true,
  parentName: 'course_creation'
};

export default generateResources(resource);
